module.exports = __webpack_public_path__ + "static/media/key-message-benefits-960w.c7241504.png";